// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__1Nhsa"};